<ng-container *ngIf="toggle; else toggledTmpl">
  <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
</ng-container>

<ng-template #toggledTmpl>
  <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
</ng-template>

<ng-template #tmpl>
  <div class="relative w-full">
    <input
      type="file"
      multiple
      [disabled]="disabled"
      accept="application/pdf, image/png, image/jpeg, image/webp, image/bmp"
      style="display: none"
      #fileInput
      (change)="onChangeFileInput()"
    />
    <ib-btn-wrap [isLoading]="fileHandling" class="w-full">
      <button
        mat-button
        [disabled]="disabled"
        class="{{
          btnClass ? btnClass : 'ib-btn-secondary ib-btn-outline w-full'
        }}"
        (click)="onClickFileInputButton()"
      >
        <span class="flex justify-center items-center">
          <i class="material-icons">attach_file</i>
        </span>
        <span>Add file</span>
      </button>
    </ib-btn-wrap>
  </div>
</ng-template>
